import React, { useEffect} from "react";
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useSelector } from "react-redux";
import "../Users.scss";
import {
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import Details from "./Details";
import AgMapping from "./AgMapping";
import { changeActiveTab } from "../../../../../slices/team/users/usersSlice";
import PspMapping from "./PspMapping";
import ProductMapping from "./ProductMapping";
import { resetFormState } from "../../../../../slices/common/reducer";
import { useDispatch } from "react-redux";
import AgsaMapping from "./AgsaMapping";
import { getEntityType } from "../../../../../Utils/CommonUtils";

const ViewUser = () => {
  const dispatch =useDispatch()
  const tabs = useSelector((state) => state.users.selectedUser.tabs);
  const activeTab = useSelector((state) => state.users.selectedUser.activeTab);

  const formState = useSelector((state) => state.common.formRendererState);
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  const entityType = getEntityType()

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
    };
  }, [dispatch]);

  const breadcrumbItems = [
    { title: "Team", link: "" },
    { title: "User", link: "/team/user" },
    { title: `${data.code}`, link: "/team/user/update" },
  ];

  const filteredTabs = ["PSP", "AGRP"].includes(entityType)
    ? tabs.filter(tab => !["psp_mapping", "ag_mapping", "agsa_mapping", "product_mapping"].includes(tab.value))
    : tabs;


  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <CardHeader>
            <SelectedTab
              tabs={filteredTabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            />
          </CardHeader>
          {/* <CardBody> */}
            {/* <div className="selected-tab-bottom-content"> */}
              {activeTab === "details" && <Details />}
              {activeTab === "psp_mapping" && <PspMapping />}
              {activeTab === "ag_mapping" && <AgMapping />}
              {activeTab === "agsa_mapping" && <AgsaMapping />}
              {activeTab === "product_mapping" && <ProductMapping />}
               {/* {entityType !== "PSP" || entityType !== "AGRP"&& (
                <>
                  {activeTab === "psp_mapping" && <PspMapping />}
                  {activeTab === "ag_mapping" && <AgMapping />}
                </>
              )} */}
            {/* </div> */}
          {/* </CardBody> */}
        </Card>
      </div>
    </>
  );

  // const handleSave=()=>{
  //   console.log("Form Data:", formState);
  // }
  // return (
  //   <>
  //     <div className="page-content">
  //       <BreadCrumb items={breadcrumbItems} />
  //       <Card>
  //         <CardHeader>
  //           {/* <SelectedTab
  //             tabs={tabs}
  //             activeTab={activeTab}
  //             changeActiveTab={changeActiveTab}
  //           /> */}
  //           {/* <div className="d-flex gap-3 renderer-tab">
  //             {userTabs.map((item, ind) => (
  //               <div className={`nav-link ${index === ind ? "active" : ""}`}
  //               onClick={() => setIndex(ind)}>
  //                 {renderElement(item, {}, {}, {}, () => {
  //                   setIndex(ind);
  //                 })}
  //               </div>
  //             ))}
  //           </div> */}

  //           <CardBody className="p-4">
  //             {/* {index === 0 && <UserDetails />} */}
  //             {/* {activeTab === "abc" && <RolesList/>} */}

  //             {/* {FormLayoutJSON.map((item, ind) => (
  //               <div>
  //                 <div className="w-100 bg-primary">
  //                   {renderElement(item, {}, {}, {}, () => {
  //                     index == ind ? setIndex(-1) : setIndex(ind);
  //                     console.log(index);
  //                   })}
  //                 </div>
  //                 <div>
  //                   {index == ind &&
  //                     FormLayoutJSON[ind].child.map((item) =>
  //                       renderElement(item, FormFieldsJSON, {}, () => {
  //                         setIndex(index);
  //                       })
  //                     )}
  //                 </div>
  //               </div>
  //             ))} */}
  //             <div className="hstack gap-2 justify-content-end">
  //               <button type="submit" className="btn btn-info" id="addNewUser" onClick={handleSave}>
  //                 Save
  //               </button>
  //             </div>
  //             <Accordion
  //               className="custom-accordionwithicon accordion-border-box"
  //               id="accordionWithouticon"
  //             >
  //               {FormLayoutJSON.map((item, ind) => (
  //                 <AccordionItem key={ind}>
  //                   <h2
  //                     className="accordion-header"
  //                     id={`accordionExample${ind}`}
  //                   >
  //                     <button
  //                       className="accordion-style"
  //                       type="button"
  //                       onClick={() => {
  //                         setIndex(index === ind ? -1 : ind);
  //                         console.log(index);
  //                       }}
  //                       style={{ cursor: "pointer" }}
  //                     >
  //                       {item.name}
  //                     </button>
  //                   </h2>

  //                   <Collapse
  //                     isOpen={index === ind}
  //                     className="accordion-collapse"
  //                     id={`accordionCollapse${ind}`}
  //                   >
  //                     <AccordionBody>
  //                       {index == ind &&
  //                         FormLayoutJSON[ind].child.map((item) =>
  //                           renderElement(item, FormFieldsJSON, formState, () => {
  //                             setIndex(index);
  //                           })
  //                         )}
  //                     </AccordionBody>
  //                   </Collapse>
  //                 </AccordionItem>
  //               ))}
  //             </Accordion>
  //           </CardBody>
  //         </CardHeader>
  //       </Card>
  //     </div>
  //   </>
  // );
};

export default ViewUser;
